import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { Observable, map, shareReplay } from 'rxjs';

// Einheitlicher Mobile-Breakpoint, ausgerichtet am Tailwind-'md'-Screen (960px)
export const MOBILE_MEDIA_QUERY = '(max-width: 959.98px)';

@Injectable({
    providedIn: 'root',
})
export class ViewportService {
    readonly isMobile$: Observable<boolean>;

    constructor(private breakpointObserver: BreakpointObserver) {
        this.isMobile$ = this.breakpointObserver
            .observe(MOBILE_MEDIA_QUERY)
            .pipe(
                map((state) => state.matches),
                shareReplay({ bufferSize: 1, refCount: false }),
            );
    }

    get isMobile(): boolean {
        return this.breakpointObserver.isMatched(MOBILE_MEDIA_QUERY);
    }

    /**
     * Dialog-Konfiguration: mobil Vollbild, am Desktop wie übergeben
     * (Default-Breite 600px wie bei den bestehenden Dialogen).
     */
    responsiveDialogConfig(desktopConfig: MatDialogConfig = {}): MatDialogConfig {
        if (!this.isMobile) {
            return { width: '600px', ...desktopConfig };
        }
        return {
            ...desktopConfig,
            width: '100vw',
            maxWidth: '100vw',
            height: '100%',
            maxHeight: '100%',
        };
    }
}
